import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/simpleTabsStyle';
import classNames from 'classnames';
import { BodyM, BodyMBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

const useStyles = makeStyles(styles);

interface ISingleTabProps {
	name: string;
	label?: string;
	hide?: boolean;
	content: React.ReactElement;
}

interface ISimpleTabsProps {
	tabs: ISingleTabProps[];
	activeTab: number;
	setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

const SimpleTabs = ({ tabs, activeTab, setActiveTab }: ISimpleTabsProps) => {
	const classes = useStyles();

	return (
		<div>
			<div className={classes.tabsWrapper}>
				{tabs.map((singleTab, index) => {
					return !singleTab.hide && (
						<div
							key={index}
							className={classNames({
								[classes.tabWrapper]: true,
								[classes.activeTabWrapper]: index === activeTab,
							})}
							onClick={() => setActiveTab(index)}
						>
							<ConditionalRender
								show={index === activeTab}
								onTrue={() => (
									<span className={classes.labelWrapper}>
										<BodyMBold color="enterprise">{singleTab.name}</BodyMBold>
										{singleTab.label ? (
											<BodyMBold customClassName={classes.label}>{singleTab.label}</BodyMBold>
										) : (
											''
										)}
									</span>
								)}
								onFalse={() => (
									<span className={classes.labelWrapper}>
										<BodyM>{singleTab.name}</BodyM>
										{singleTab.label ? (
											<BodyM customClassName={classes.label}>{singleTab.label}</BodyM>
										) : (
											''
										)}
									</span>
								)}
							/>
						</div>
					);
				})}
			</div>
			<div className={classes.contentWrapper}>{tabs[activeTab].content}</div>
		</div>
	);
};

export default SimpleTabs;
